module.exports = __webpack_public_path__ + "static/media/siren2.fba8bbc9.aac";